export const THEME_MODE_KEY = "THEME_MODE";